import { normalize } from 'normalizr';

import * as schema from '../schema';
import * as types from '../constants';
import Http from '../../../http';
import { startLoadingList, stopLoadingList } from '../../../common/hoc/withLoaingList';
import { include } from './shop';
import { ChurnZeroService, ADD_BARBER, DELETE_BARBER } from '../../../../modules/infra/observability/churnzero';
import { getDeletedBarbers } from './common';
import { ADD_BRAND_BARBER_DAY_OFF, REMOVE_BRAND_BARBER_DAY_OFF } from '../constants';

export function getBarbers(brandId) {
  return (dispatch) => {
    dispatch(startLoadingList());

    return (
      Http.get(`/brand/${brandId}/barber`, { sortBy: 'order:asc,createdAt:desc' })
        .then((barbers) => {
          dispatch({
            type: types.GET_BARBERS,
            response: normalize(barbers, schema.arrayOfBarbers),
          });
          dispatch(stopLoadingList());

          return barbers;
        })
        .catch((err) => {
          dispatch(stopLoadingList());
          return err;
        })
    );
  };
}

export function getBarber(brandId, barberId) {
  return dispatch => Http.get(`/brand/${brandId}/barber/${barberId}`, {
    include: [...include, 'days_off'].join(','),
  }).then((barber) => {
    dispatch({ type: types.GET_SINGLE_BRAND_BARBER });

    dispatch({
      type: types.SET_SINGLE_BRAND_BARBER,
      barberId,
      response: normalize(barber.profiles, schema.brandBarberForEdit),
    });

    return barber.profiles;
  });
}

export function resetBarber() {
  return (dispatch) => {
    dispatch({ type: types.RESET_SINGLE_BRAND_BARBER });
  };
}

export function updateBarber(brandId, barberId, data) {
  return dispatch => Http.put(`/brand/${brandId}/barber/${barberId}`, data).then((barber) => {
    dispatch({
      type: types.SET_SINGLE_BRAND_BARBER,
      barberId,
      response: normalize(barber.profiles, schema.brandBarberForEdit),
    });
    return barber.profiles;
  });
}

export function addBarber(brandId, data) {
  return dispatch => Http.post(`/brand/${brandId}/barber`, data).then((barber) => {
    const normalizedResponse = normalize(barber.profiles, schema.brandBarberForEdit);

    dispatch({
      type: types.SET_SINGLE_BRAND_BARBER,
      barberId: barber.id,
      response: normalizedResponse,
    });

    ChurnZeroService.track(ADD_BARBER);
    return barber;
  });
}

export function deleteBarber(brandId, barberId) {
  return dispatch => Http.delete(`/brand/${brandId}/barber/${barberId}`).then((res) => {
    dispatch({ type: types.DELETE_BARBER, barberId });
    ChurnZeroService.track(DELETE_BARBER);
    return res;
  });
}

export const generateBrandBarberPermissionPasscode = (brandId, barberId) => dispatch =>
  Http.post(`/brand/${brandId}/barber/${barberId}/generate-permission-passcode`).then(brandBarberPasscodes =>
    dispatch({
      type: types.SET_BRAND_BARBER_PERMISSION_CODE,
      payload: brandBarberPasscodes.profiles,
    })
  );

export const setBrandBarberPermissionPasscode = (brandId, barberId, code) => (dispatch) => {
  dispatch({ type: types.BARBER_SET_PERMISSION_CODE_LOADING });

  return Http.post(`/brand/${brandId}/barber/${barberId}/set-permission-passcode`, { code })
    .finally(() => dispatch({ type: types.BARBER_SET_PERMISSION_CODE_LOADED }))
    .then(brandBarberPasscodes =>
      dispatch({
        type: types.SET_BRAND_BARBER_PERMISSION_CODE,
        payload: brandBarberPasscodes.profiles,
      })
    );
};

export function restoreDeletedBrandBarber(brandId, barberId) {
  return dispatch => Http.put(`/brand/${brandId}/barber/${barberId}/restore`)
    .then((barber) => {
      dispatch({
        type: types.RESTORE_SINGLE_BARBER,
        payload: barber,
      });
      dispatch(getDeletedBarbers(brandId, 'brand'));
    });
}

export const addBrandBarberDayOff = (barberShopId, dayOffIndex, dayOff) => ({
  type: ADD_BRAND_BARBER_DAY_OFF,
  payload: {
    shopId: barberShopId,
    dayOffIndex,
    dayOff,
  },
});

export const removeBrandBarberDayOff = (barberShopId, dayOffIndex) => ({
  type: REMOVE_BRAND_BARBER_DAY_OFF,
  payload: {
    shopId: barberShopId,
    dayOffIndex,
  },
});
